var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',{staticClass:"content-card"},[_c('iframe',{attrs:{"src":_vm.iframeSrc,"frameborder":"0","width":"100%","height":"1750px"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }